import { styled, Tag } from '@grupoboticario/flora-react';

export const styles = {
  tag: {
    textTransform: 'capitalize',
    cursor: 'default',
    fontWeight: 'bolder',
  },
};

export const TagStyles = styled(Tag, {
  '&[data-variant-orders="disabled"]': {
    background: '$backgroundTertiary',
    color: '$nonInteractivePredominant',
  },
  '&[data-variant-orders="alert"]': {
    background: '$alert-standard',
    color: '$nonInteractivePredominant',
  },
  '&[data-variant-orders="success"]': {
    background: '$success-standard',
    color: '$nonInteractivePredominant',
  },
  '&[data-variant-orders="error"]': {
    background: '$error-standard',
    color: '$nonInteractiveAltPredominant',
  },
});
